import React, { useEffect, useState, createContext, useContext } from 'react';
// 🔑 LLAVE DE ACCESO ÚNICA
// Si quieres cambiarla en el futuro, solo edita esta constante.
const VALID_ACCESS_KEY = '2xGrRVQ5UaNJYaqqHuFkpG7oqvCbm9i5Fgwg6v';
const STORAGE_KEY = 'growthly_access_v2';
export interface User {
  name: string;
  role: string;
  company: string;
  email?: string;
}
const DEFAULT_USER: User = {
  name: 'Ivana Jovanoska Risteska',
  role: 'Marketing Manager',
  company: 'Growthly Corporation Systems'
};
interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  loginWithKey: (key: string) => Promise<void>;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export function AuthProvider({
  children
}: {
  children: ReactNode;
}) {
  const [user, setUser] = useState<User | null>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  const [loading] = useState(false);
  useEffect(() => {
    if (user) localStorage.setItem(STORAGE_KEY, JSON.stringify(user));else localStorage.removeItem(STORAGE_KEY);
  }, [user]);
  const loginWithKey = async (key: string) => {
    // Pequeño delay para UX (spinner visible)
    await new Promise(r => setTimeout(r, 400));
    if (key.trim() !== VALID_ACCESS_KEY) {
      throw new Error('Llave de acceso incorrecta');
    }
    setUser(DEFAULT_USER);
  };
  const logout = () => {
    setUser(null);
  };
  return <AuthContext.Provider value={{
    user,
    isAuthenticated: !!user,
    loading,
    loginWithKey,
    logout
  }} data-id="element-775">
      {children}
    </AuthContext.Provider>;
}
export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};